import styles from './MPTLeLabo.module.css'

// Le visuel est porté par le CSS (paysage ou carré selon la largeur de
// l'en-tête) : seule l'image affichée est téléchargée.
const MPTLeLabo = () => (
  <header className={styles.header}>
    <div className={styles.band}>
      <div
        className={styles.visual}
        role="img"
        aria-label="Le Labo, révélateur de talents – Maisons pour tous Léo Lagrange. Candidature ouverte aux groupes ou artistes solo amateurs jusqu'au 27 novembre 2026. Dossier de candidature à retirer dans les Maisons pour tous ou sur montpellier.fr/labo. Renseignements : 04 48 18 62 18."
      />
    </div>
  </header>
)

export default MPTLeLabo
